<template>
  <div
    class="vs-collapse-item"
    :class="{ 'open-item': isOpen, disabledx: disabled }"
    @mouseover="handleMouseover"
    @mouseout="handleMouseout"
  >
    <header class="vs-collapse-item--header" @click="toggleContent">
      <slot name="header" />
      <span
        v-if="!notArrow"
        class="icon-header vs-collapse-item--icon-header"
      >
        <vs-icon :icon-pack="iconPack" :icon="iconArrow" />
      </span>
    </header>
    <div
      ref="content"
      class="vs-collapse-item--content"
      :style="{ maxHeight }"
    >
      <div class="con-content--item"><slot /></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "VsCollapseItem",
  inject: ["vsCollapse"],
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    notArrow: {
      type: Boolean,
      default: false,
    },
    iconArrow: {
      type: String,
      default: "keyboard_arrow_down",
    },
    iconPack: {
      type: String,
      default: "material-icons",
    },
    sst: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["fetch"],
  data() {
    return {
      maxHeight: "0px",
      dataReady: false,
    };
  },
  computed: {
    collapse() {
      return this.vsCollapse;
    },
    isOpen() {
      return this.maxHeight !== "0px";
    },
  },
  watch: {
    maxHeight() {
      this.collapse.emitChange();
    },
  },
  created() {
    this.collapse.registerItem(this);
  },
  mounted() {
    window.addEventListener("resize", this.changeHeight);
    if (this.open) this.openContent();
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.changeHeight);
    this.collapse.unregisterItem(this);
  },
  methods: {
    contentHeight() {
      return this.$refs.content ? this.$refs.content.scrollHeight : 0;
    },
    changeHeight() {
      if (this.isOpen) this.maxHeight = `${this.contentHeight()}px`;
    },
    toggleContent() {
      if (this.collapse.openHover || this.disabled) return;
      if (this.collapse.accordion) this.collapse.closeAllItems(this);

      if (this.sst && !this.dataReady) {
        this.$emit("fetch", {
          done: () => {
            this.toggleHeight();
            this.dataReady = true;
          },
        });
      } else {
        this.toggleHeight();
      }
    },
    toggleHeight() {
      if (this.isOpen) this.close();
      else this.openContent();
    },
    openContent() {
      this.maxHeight = `${this.contentHeight()}px`;
    },
    close() {
      this.maxHeight = "0px";
    },
    handleMouseover() {
      if (!this.disabled && this.collapse.openHover) this.openContent();
    },
    handleMouseout() {
      if (this.collapse.openHover) this.close();
    },
  },
};
</script>
